import AiAgentsAPI from '../../api/aiAgents';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
  meta: {
    llm_token_balance: 0,
    max_llm_tokens: 0,
  },
};

export const getters = {
  getAiAgents($state) {
    return $state.records;
  },
  getMeta($state) {
    return $state.meta;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await AiAgentsAPI.get();
      if (response.data && response.data.payload) {
        commit('SET_AI_AGENTS', response.data.payload);
        commit('SET_META', response.data.meta);
      } else {
        commit('SET_AI_AGENTS', response.data);
      }
    } catch (error) {
      // Ignore
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await AiAgentsAPI.create(data);
      commit('ADD_AI_AGENT', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...data }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await AiAgentsAPI.update(id, data);
      commit('EDIT_AI_AGENT', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await AiAgentsAPI.delete(id);
      commit('REMOVE_AI_AGENT', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  SET_AI_AGENTS($state, data) {
    $state.records = data;
  },
  SET_META($state, data) {
    $state.meta = data;
  },
  ADD_AI_AGENT($state, data) {
    $state.records.push(data);
  },
  EDIT_AI_AGENT($state, data) {
    const index = $state.records.findIndex(record => record.id === data.id);
    if (index !== -1) {
      $state.records.splice(index, 1, data);
    }
  },
  REMOVE_AI_AGENT($state, id) {
    $state.records = $state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
